import React from 'react';
import { AWAITING_CUSTOMER_REVIEW } from '../../../../constants/issueStatuses';
import { StatusBadgeWrapper } from './StatusBadge.styles';

const StatusBadge = ({ status }) => {
  return (
    <StatusBadgeWrapper status={status}>
      {status === AWAITING_CUSTOMER_REVIEW ? 'Needs Review' : status}
    </StatusBadgeWrapper>
  );
};

export default StatusBadge;
